// @ts-nocheck
import React, { useState } from 'react';
import Layout from '../components/Layout';
import HedgePerformers from '../components/HedgePerformers';
import HedgePerformersETH from '../components/HedgePerformersETH';
import PriceComparisonBTC from '../components/PriceComparisonBTC';
import PriceComparisonETH from '../components/PriceComparisonETH';
import BullMarketSupportBandUSD from '../components/BullMarketSupportBandUSD';
import BullMarketSupportBandBTC from '../components/BullMarketSupportBandBTC';
import TechnicalIndicators from '../components/TechnicalIndicators';
import { useTheme } from '../contexts/ThemeContext';
import { Shield, TrendingUp, BarChart3, Activity } from 'lucide-react';

const Explore = () => {
  const { isDark } = useTheme();
  const [activeTab, setActiveTab] = useState('hedge-btc');

  const tabs = [
    { id: 'hedge-btc', label: 'Hedge vs BTC', icon: Shield, component: <HedgePerformers /> },
    { id: 'hedge-eth', label: 'Hedge vs ETH', icon: Shield, component: <HedgePerformersETH /> },
    { id: 'price-btc', label: 'vs BTC Performance', icon: Activity, component: <PriceComparisonBTC /> },
    { id: 'price-eth', label: 'vs ETH Performance', icon: Activity, component: <PriceComparisonETH /> },
    { id: 'bmsb-usd', label: 'Bull Support (USD)', icon: TrendingUp, component: <BullMarketSupportBandUSD /> },
    { id: 'bmsb-btc', label: 'Bull Support (BTC)', icon: TrendingUp, component: <BullMarketSupportBandBTC /> },
    { id: 'tech-indicators', label: 'Technical Indicators', icon: BarChart3, component: <TechnicalIndicators /> },
  ];

  return (
    <Layout>
      <div className={`min-h-screen ${isDark ? 'bg-zinc-900' : 'bg-gray-50'}`}>
        {/* Hero Section */}
        <div className="relative overflow-hidden">
          {/* Background gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 opacity-10"></div>
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iIzAwMCIgb3BhY2l0eT0iLjA1Ii8+PC9nPjwvc3ZnPg==')] opacity-30"></div>

          <div className="relative max-w-7xl mx-auto px-6 py-12">
            <div className="text-center">
              <h1 className="text-5xl md:text-6xl font-bold mb-4">
                <span className="bg-gradient-to-r from-emerald-600 via-teal-600 to-cyan-600 bg-clip-text text-transparent">
                  Explore
                </span>
                <br />
                <span className={isDark ? 'text-white' : 'text-gray-900'}>Markets</span>
              </h1>
              <p className={`text-lg mb-2 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                Advanced market analysis tools and performance metrics
              </p>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-emerald-500/10 to-cyan-500/10 border border-emerald-500/20">
                <span className="text-2xl">📊</span>
                <span className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                  7 Trading Strategies
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Tabs */}
          <div className={`mb-6 border-b ${
            isDark ? 'border-zinc-800' : 'border-gray-200'
          }`}>
            <div className="flex gap-2 overflow-x-auto pb-2">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`px-4 py-2 rounded-t-lg font-medium text-sm whitespace-nowrap transition-all duration-200 flex items-center gap-2 ${
                      activeTab === tab.id
                        ? isDark
                          ? 'bg-zinc-900 text-white border-b-2 border-emerald-500'
                          : 'bg-white text-emerald-600 border-b-2 border-emerald-500'
                        : isDark
                          ? 'text-gray-400 hover:text-white hover:bg-zinc-900/50'
                          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                    }`}
                  >
                    <Icon size={16} className={activeTab === tab.id ? 'text-emerald-500' : ''} />
                    {tab.label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Active Tab Content */}
          <div>
            {tabs.find(tab => tab.id === activeTab)?.component}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Explore;
